class SiteHeader extends HTMLElement {
  isTicking = false
  lastKnownY = window.scrollY
  offsetTrackedY = 0
  scrollOffset = 150
  safeZone = 0
  scrollDirection = ''

  constructor () {
    super()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)

    this.updateEl()
  }

  connectedCallback () {
    this.onScroll = this.onScroll.bind(this)

    document.addEventListener('scroll', this.onScroll)
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    const previousDirection = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    if (previousDirection !== this.scrollDirection) {
      this.offsetTrackedY = this.lastKnownY
    }

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setOpacity()

    if (
      this.lastKnownY > window.innerHeight ||
      this.lastKnownY <= this.safeZone
    ) {
      this.setVisibility()
    }
  }

  setOpacity () {
    this.classList.toggle(
      this.dataset.headerCondensedClass,
      this.headerIsCondensed
    )
    document.body.classList.toggle(
      this.dataset.bodyCondensedClass,
      this.headerIsCondensed
    )
  }

  setVisibility () {
    if (this.shouldBeVisible !== this.wasVisible) {
      document.dispatchEvent(
        new CustomEvent('header-visibility', {
          detail: {
            isHidden: !this.shouldBeVisible
          }
        })
      )
      this.classList.toggle(
        this.dataset.headerHiddenClass,
        !this.shouldBeVisible
      )
      document.body.classList.toggle(
        this.dataset.bodyHiddenClass,
        !this.shouldBeVisible
      )
      this.wasVisible = this.shouldBeVisible
    }
  }

  get shouldBeVisible () {
    if (
      this.lastKnownY <=
      (document.body.classList.contains('lyt-Site-transparentHeader')
        ? 1
        : this.offsetHeight)
    ) {
      return true
    }

    if (this.scrollDirection === 'down') {
      return false
    } else if (this.scrollDirection === 'up') {
      return this.isOverOffset
    }
  }

  get isOverOffset () {
    if (this.scrollDirection === 'down') {
      return this.lastKnownY >= this.offsetTrackedY + this.scrollOffset
    } else if (this.scrollDirection === 'up') {
      return this.lastKnownY <= this.offsetTrackedY - this.scrollOffset
    }
  }

  get headerIsCondensed () {
    return this.lastKnownY > this.safeZone
  }
}

customElements.define('site-header', SiteHeader, {
  extends: 'header'
})
